/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMunicipalCommand } from '../../models/create-municipal-command';
import { CreateMunicipalCommandResult } from '../../models/create-municipal-command-result';

export interface ApiMunicipalCreateMunicipalPost$Plain$Params {
      body?: CreateMunicipalCommand
}

export function apiMunicipalCreateMunicipalPost$Plain(http: HttpClient, rootUrl: string, params?: ApiMunicipalCreateMunicipalPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMunicipalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMunicipalCreateMunicipalPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMunicipalCommandResult>;
    })
  );
}

apiMunicipalCreateMunicipalPost$Plain.PATH = '/api/Municipal/CreateMunicipal';
